import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
  .shell-base-table {
    border: none;
  }
`;
